import React from "react";
import SliderBlock from "../components/SliderBlock";
import { StaticImage } from "gatsby-plugin-image";
import DefaultButton from "../components/buttons/DefaultButton";

const SliderOne = (props) => (
  <SliderBlock title="Scopri le nostre soluzioni di prestito e finanziamento" bgColor="#e8f0f6" className="mt-5" id="section-prodotti">
    <div>
      <StaticImage
        src="../assets/images/sl-1-cess-quinto-pensionati.png"
        className="img-fluid mx-auto"
        alt="Cessione del Quinto per pensionati"
        placeholder="blurred"
        layout="fixed"
        width={336}
        height={252}
      />
      <h4 className="slick_slide__title">
        Cessione del Quinto <br />
        per pensionati
      </h4>
      <p className="slick_slide__description">
        Con la Cessione del Quinto per pensionati di Prestiti Fai da Te puoi
        richiedere fino a 75.000€ rimborsabili direttamente dalla tua pensione e
        approfittare di tassi agevolati in convenzione* INPS, ex INPDAP, ex
        ENPALS.
      </p>
      <DefaultButton
        title="Approfondisci"
        url="/cessione-del-quinto-per-pensionati"
        className="mt-5 btn-outline-dark"
      />
    </div>
    <div>
      <StaticImage
        src="../assets/images/sl1-cess-quinto-NoiPA.png"
        className="img-fluid mx-auto"
        alt="Cessione del Quinto NoiPA"
        placeholder="blurred"
        layout="fixed"
        width={336}
        height={252}
      />
      <h4 className="slick_slide__title">Cessione del Quinto NoiPA</h4>
      <p className="slick_slide__description">
        Condizioni di finanziamento a tasso super-agevolato per i dipendenti
        pubblici o para-pubblici. Senza bisogno di fornire garanzie perché la
        busta paga da sola assicura l’accesso diretto ai tassi dedicati.
      </p>
      <DefaultButton
        title="Approfondisci"
        url="/cessione-del-quinto-noipa"
        className="mt-5 btn-outline-dark"
      />
    </div>
    <div>
      <StaticImage
        src="../assets/images/sl1-prest-personali-insegnanti.png"
        className="img-fluid mx-auto"
        alt="Prestiti Personali per Insegnanti Pubblici e Statali"
        placeholder="blurred"
        layout="fixed"
        width={336}
        height={252}
      />
      <h4 className="slick_slide__title">
        Prestiti Personali per Insegnanti Pubblici e Statali
      </h4>
      <p className="slick_slide__description">
        La formula 100% online di Prestiti Fai da Te è la soluzione trasparente,
        sicura e conveniente per gli insegnanti di scuola pubblica o statale e
        personale ATA. Basta la tua busta paga, senza altre garanzie.
      </p>
      <DefaultButton
        title="Approfondisci"
        url="/cessione-del-quinto-per-pensionati"
        className="mt-5 btn-outline-dark"
      />
    </div>
    <div>
      <StaticImage
        src="../assets/images/sl1-finanziam-ristrutturazione-casa.png"
        className="img-fluid mx-auto"
        alt="Finanziamento Ristrutturazione Casa"
        placeholder="blurred"
        layout="fixed"
        width={336}
        height={252}
      />
      <h4 className="slick_slide__title">
        Finanziamento Ristrutturazione Casa
      </h4>
      <p className="slick_slide__description">
        Con il finanziamento per ristrutturazione casa di PrestitiFaidaTe oggi
        puoi avere liquidità immediata per affrontare il tuo progetto con la
        serenità e la tranquillità che ti serve. Alle spese per ora lascia che
        ci pensiamo noi.
      </p>
      <DefaultButton
        title="Approfondisci"
        url="/finanziamento-ristrutturazione-casa"
        className="mt-5 btn-outline-dark"
      />
    </div>
  </SliderBlock>
);
export default SliderOne;
